import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import * as fromCustomViewsUi from './+state/custom-views-ui.reducer';
import { CustomViewsUiFacade } from './+state/custom-views-ui.facade';
import { CustomViewsUiEffects } from './+state/custom-views-ui.effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(fromCustomViewsUi.customViewsFeature),
        EffectsModule.forFeature([CustomViewsUiEffects]),
    ],
    providers: [CustomViewsUiFacade],
})
export class SharedStoresCustomViewsUiModule {}
